import React from 'react';

interface TableRowProps extends React.HTMLAttributes<HTMLTableRowElement> {
  children: React.ReactNode;
  className?: string;
}

const TableRow = ({ children, className = '', ...props }: TableRowProps) => (
  <tr className={className} {...props}>
    {children}
  </tr>
);

export default TableRow;
